import { useContext, useEffect } from "react";
import classes from "./learningPath.module.css";
import testStyles from "../../pages/TalentDashboard/Test/testRedesign.module.css";
import {
  BorderPoint,
  CloseIcon,
  LightStar,
} from "../../constants/svg";
import { IconArrowRight, IconSparkles, IconX } from "@tabler/icons-react";
import { WhiteButton } from "../UI/Button/button";
import { useState } from "react";
import {
  submitTalentImprovementSkills,
  talentRoles,
} from "../../services/talentCalls";
import TestModalComponent from "../../pages/TalentDashboard/Test/components/Modal/testModal";
import Select from "react-select";
import Loop2 from "../../assets/loader/loop2.svg";
import { UserContext } from "../../context";
import FullScreenLoader from "../Loaders/FullScreen/loader";
import Slider from "react-slick";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const skillSelectStyle = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    height: 44,
    borderRadius: 10,
    borderColor: state.isFocused ? "var(--blue)" : "var(--border)",
    backgroundColor: state.isFocused ? "var(--white)" : "var(--bg-soft)",
    boxShadow: state.isFocused ? "0 0 0 3px #eff2ff" : "none",
    transition: "border-color 0.15s, background 0.15s",
    "&:hover": { borderColor: "var(--blue)" },
  }),
  valueContainer: (base) => ({ ...base, height: 44, padding: "0 14px" }),
  input: (base) => ({ ...base, margin: 0, padding: 0, color: "var(--text-primary)" }),
  placeholder: (base) => ({ ...base, color: "var(--text-muted)", fontSize: 14 }),
  singleValue: (base) => ({ ...base, color: "var(--text-primary)", fontSize: 14 }),
  indicatorsContainer: (base) => ({ ...base, height: 44 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, color: "var(--text-muted)" }),
  menuPortal: (base) => ({ ...base, zIndex: 10000 }),
  menu: (base) => ({
    ...base,
    borderRadius: 10,
    border: "1px solid var(--border)",
    boxShadow: "var(--shadow-md)",
    overflow: "hidden",
    marginTop: 6,
  }),
  menuList: (base) => ({ ...base, padding: 4 }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    borderRadius: 6,
    padding: "9px 12px",
    cursor: "pointer",
    backgroundColor: state.isSelected ? "#eff2ff" : state.isFocused ? "var(--bg-soft)" : "transparent",
    color: state.isSelected ? "var(--blue)" : "var(--text-primary)",
    fontWeight: state.isSelected ? 600 : 400,
  }),
};

const Improvement = ({
  handleTalentSubscribe,
  subscribeLoading,
  isUnlock,
  data,
  handleGetImprovementAnswers,
  type = "talent",
  setDisclaimerModal,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openTestModal, setOpenTestModal] = useState(false);
  const [allTalentRoles, setAllTalentRoles] = useState([]);
  const [role, setRole] = useState(null);
  const [test, setTest] = useState(null);
  const [attempt, setAttempt] = useState(null);
  const [skillLoading, setSkillLoading] = useState(false);
  const { skillModal, setSkillModal } = useContext(UserContext);

  const handleRoleChange = (selected) => {
    setRole(selected);
  };

  const fetchTalentRoles = async () => {
    try {
      const res = await talentRoles();
      if (res?.data.data.records) {
        const sortedRoles = [...res.data.data.records].sort((a, b) =>
          a.name.localeCompare(b.name),
        );

        setAllTalentRoles(sortedRoles);
      }
    } catch (e) {
      console.error("");
    }
  };

  const handleSubmitSkill = async () => {
    setSkillLoading(true);
    try {
      const data = {
        skills: role?.map((r) => r.value),
      };
      const res = await submitTalentImprovementSkills(data);
      if (res?.data?.success && res?.data?.data?.data?.test) {
        setTest(res?.data?.data?.data?.test);
      }
      if (res?.data?.success && res?.data?.data?.data?.attempt) {
        setAttempt(res?.data?.data?.data?.attempt);
      }
    } catch (e) {
      console.error("");
    } finally {
      setSkillLoading(false);
    }
  };

  useEffect(() => {
    fetchTalentRoles();
  }, []);

  useEffect(() => {
    if (test) {
      setSkillModal(false);
      setOpenTestModal(true);
    }
  }, [test]);

  return (
    <div
      type="container"
      className={`relative min-h-[180px] ${classes.improvements} ${
        type !== "company" ? "flex-1 flex flex-col" : "h-full"
      }`}
    >
      {type === "talent" ? (
        <div className={`${classes.eduHeader} flex items-center mb-6`}>
          <h3 className={classes.topTitle}>What to Improve on</h3>
          <span className={classes.line}></span>
          <span className={classes.star}>
            NEW <LightStar />{" "}
          </span>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <h2 className="text-2xl font-medium text-[#152238]">
            What to Improve on
          </h2>
          <div className="lg:flex items-center gap-2 justify-end lg:mb-10 hidden">
            <BorderPoint />
          </div>
        </div>
      )}

      <div className="flex-1 flex flex-col">
        <ImprovementContent
          isUnlock={isUnlock}
          setSkillModal={setSkillModal}
          data={data}
          setOpenModal={setOpenModal}
          setDisclaimerModal={setDisclaimerModal}
        />
      </div>


      {openModal && (
        <ImprovementModal
          setOpenModal={setOpenModal}
          isUnlock={isUnlock}
          setSkillModal={setSkillModal}
          data={data}
          setDisclaimerModal={setDisclaimerModal}
        />
      )}
      {openTestModal && (
        <TestModal
          test={test}
          setTest={setTest}
          attempt={attempt}
          setAttempt={setAttempt}
          setOpenTestModal={setOpenTestModal}
          handleGetImprovementAnswers={handleGetImprovementAnswers}
        />
      )}
      {skillModal && (
        <SelectSkillModal
          setSkillModal={setSkillModal}
          allTalentRoles={allTalentRoles}
          role={role}
          handleRoleChange={handleRoleChange}
          loading={skillLoading}
          handleSubmitSkill={handleSubmitSkill}
        />
      )}
      {!isUnlock && (
        <div className="flex justify-center absolute top-1/2 right-1/2 translate-x-1/2 mt-auto">
          <WhiteButton
            className="!w-full mx-auto lg:mx-0 no-print min-w-[220px]"
            onClick={handleTalentSubscribe}
            disabled={subscribeLoading}
          >
            Unlock all premium insights with &#8358;5,000
          </WhiteButton>
        </div>
      )}
    </div>
  );
};

export default Improvement;

export const ImprovementModal = ({
  setOpenModal,
  isUnlock,
  setDisclaimerModal,
  data,
}) => {
  return (
    <div className={`${classes.modalOverlay}`}>
      <div className={classes.modalContent}>
        <span
          className="ml-auto justify-end flex"
          onClick={() => setOpenModal(false)}
        >
          <CloseIcon color={"#030659"} />
        </span>
        <ImprovementContent
          isUnlock={isUnlock}
          setDisclaimerModal={setDisclaimerModal}
          data={data}
          setOpenModal={setOpenModal}
        />
      </div>
    </div>
  );
};

export const SelectSkillModal = ({
  setSkillModal,
  allTalentRoles,
  role,
  handleRoleChange,
  loading,
  handleSubmitSkill,
}) => {
  return (
    <div className={classes.modalOverlay}>
      <div className={testStyles.authCard}>
        <button
          type="button"
          className={testStyles.authCloseBtn}
          onClick={() => setSkillModal(false)}
          aria-label="Close"
        >
          <IconX size={15} />
        </button>
        <div className={testStyles.authHero}>
          <div className={testStyles.authHeroIcon}>
            <IconSparkles size={26} color="#fff" />
          </div>
          <div className={testStyles.authHeroTitle}>Awa-AI Skill Test</div>
          <div className={testStyles.authHeroSub}>Select the role you'd like Awa-AI to test you on.</div>
        </div>
        <div className={testStyles.authPad}>
          <div className={testStyles.fieldGroup}>
            <label className={testStyles.fieldLabel}>Role</label>
            <Select
              styles={skillSelectStyle}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              placeholder="Select an option from the drop down"
              value={role}
              onChange={handleRoleChange}
              isSearchable
              isClearable
              name="primaryRole"
              options={allTalentRoles.map((role) => ({
                label: role.label || role.name,
                value: role.name,
              }))}
            />
          </div>

          {loading ? (
            <img src={Loop2} alt="loader" className="mx-auto" />
          ) : (
            <button
              type="button"
              className={`${testStyles.btnAmber} ${testStyles.authBtnFull}`}
              onClick={handleSubmitSkill}
              disabled={loading}
            >
              <IconArrowRight size={15} /> Start Test
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
export const TestModal = ({
  setOpenTestModal,
  test,
  setTest,
  handleGetImprovementAnswers,
  attempt,
  setAttempt,
}) => {
  const [loading, setLoading] = useState(false);
  return (
    <div className={`${classes.modalOverlay}`}>
      {loading && <FullScreenLoader />}
      <div className={`${classes.testModalContent} p-4`}>
        <TestModalComponent
          test={test}
          setTest={setTest}
          attempt={attempt}
          setAttempt={setAttempt}
          setModal={setOpenTestModal}
          handleGetImprovementAnswers={handleGetImprovementAnswers}
          loading={loading}
          setLoading={setLoading}
        />
      </div>
    </div>
  );
};

export const ImprovementContent = ({
  isUnlock,
  setDisclaimerModal,
  data,
  setOpenModal,
}) => {
  const slides = Array.isArray(data)
    ? data.filter((item) => item?.testResult?.skillsAnalysis?.length > 0)
    : [];

  const settings = {
    dots: slides.length > 1,
    infinite: slides.length > 1,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div
      className={`relative improvement-slider !mt-0 !px-0 !border-none lg:min-h-full ${classes.aiMainContainer}`}
      type="container"
    >
      <div className={`${isUnlock ? "" : classes.blurred} lg:flex lg:flex-col lg:min-h-full lg:justify-between`}>
        {data?.length === 0 && (
          <p className="text-base mb-9 text-[#152238] text-center">
            You have not taken the psychometric test yet
          </p>
        )}

        {Array.isArray(data) && data.length > 0 && (
          <p className="text-base mb-9">
            From our analysis of your psychometric test we have concluded that
            you work on the following aspects of skill set as they might be your
            weak points:
          </p>
        )}

        {slides.length > 0 ? (
          <Slider {...settings}>
            {slides.map((item, index) => (
              <div key={index}>
                {item.testResult.skillsAnalysis.map((skill, skillIndex) => (
                  <div key={skillIndex} className="mb-6">
                    <h3 className="mb-2 font-semibold">{skill.skill}</h3>

                    <div className="lg:grid grid-cols-1 gap-x-2 py-4">
                      {skill?.summary && (
                        <div className="pb-3 pr-3">
                          <h4 className="text-xs font-medium text-[#EB9B01] mb-2">
                            Summary
                          </h4>
                          <p className="text-xs">{skill?.summary}</p>
                        </div>
                      )}

                      {skill?.weaknesses?.length > 0 && (
                        <div className="pb-3 pr-3">
                          <h4 className="text-xs font-medium text-[#EB9B01] mb-2">
                            Weaknesses
                          </h4>
                          <p className="text-xs">
                            {skill?.weaknesses?.join(", ")}
                          </p>
                        </div>
                      )}
                      {skill?.strengths?.length > 0 && (
                        <div className="mb-3">
                          <h4 className="text-xs font-medium text-[#EB9B01] mb-2">
                            Strengths
                          </h4>
                          <p className="text-xs">
                            {skill?.strengths?.join(", ")}
                          </p>
                        </div>
                      )}
                    </div>

                   {skill?.improvementAreas?.length > 0 &&
                   <div className="mb-8">
                      {skill?.improvementAreas?.map((area, idx) => (
                        <div
                          key={idx}
                          className="grid grid-cols-1 gap-2 mb-2"
                        >
                          <span className="text-[#EB9B01] break-words text-xs">
                            {area?.area}
                          </span>
                          <span className="text-xs font-light">
                            {area?.reason}
                          </span>
                        </div>
                      ))}
                    </div>
                    }
                  </div>
                ))}
              </div>
            ))}
          </Slider>
        ) : (
          data?.length > 0 && (
            <p className="text-base mb-4 text-[#152238] text-center">
              No skill analysis available for this test result.
            </p>
          )
        )}

        {data?.length === 0 && (
          <p className="text-base mb-4 text-[#152238] text-center">
            Click below to take test
          </p>
        )}

        <div className="flex mx-auto justify-center mt-auto pt-10 pb-4">
          <WhiteButton
            className="min-w-[182px] max-w-[182px] mx-auto lg:mx-0 no-print"
            onClick={() => {
              setDisclaimerModal(true);
              setOpenModal(false);
            }}
          >
            {data?.length === 0 ? "Take Test" : "Take Another Test"}
          </WhiteButton>
        </div>
      </div>
    </div>
  );
};
